import { FormattedMessage } from 'react-intl';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useSearchBar } from '@xing-com/crate-jobs-hooks';
import { useExperiment } from '@xing-com/hub';
import { IconAIFilled } from '@xing-com/icons';
import { Marker } from '@xing-com/marker';

import * as S from './conversational-search-bar.styles';
import { SearchBar } from './search-bar';

export const ConversationalSearchBar: React.FC = () => {
  const { keywords, location, onSubmit, ...result } = useSearchBar();
  const { isLoggedIn } = useLoginState();

  const isAiSearchForcedLI = useExperiment('ABACUS-468') === 'B' && isLoggedIn;
  const isAiSearchForcedLO = useExperiment('ABACUS-496') === 'B' && !isLoggedIn;
  const isAiSearchForced = isAiSearchForcedLI || isAiSearchForcedLO;

  return (
    <S.Container>
      <S.FlagsContainer>
        <Marker icon={IconAIFilled} variant="ai">
          <FormattedMessage id="JOBS_SEARCH_AI_FLAG" />
        </Marker>
        {isAiSearchForced ? null : <Marker variant="onColor">Beta</Marker>}
      </S.FlagsContainer>
      <S.Title>
        <FormattedMessage id="JOBS_SEARCH_AI_HEADLINE" />
        <S.Icon />
      </S.Title>
      <SearchBar
        keywordsInput={keywords}
        locationInput={location}
        onSubmit={onSubmit}
        {...result}
      />
    </S.Container>
  );
};
